module.exports = __webpack_public_path__ + "img/us2.03fd8644.png";